import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';

import InstantSearchWidgetBundle from './bundle';
import ImageSkeleton from 'src/assets/images/common/image-skeleton.png';

class InstantSearchWidgetPreview extends Component<ComposedProps, State> {
  render() {
    const { formValues, widget, filterSettings } = this.props;
    const { search = {} } = filterSettings;
    const {
      suggestionStyle = 'style2',
      suggestionStyle1ProductPosition = 'right',
      suggestionStyle2ProductPosition = 'right',
      suggestionStyle3ProductPosition = 'right'
    } = search;

    // Hardcode data
    const suggestionStyle1ProductItemType = 'list',
      suggestionStyle1ProductPerRow = 1,
      suggestionStyle2ProductItemType = 'grid',
      suggestionStyle2ProductPerRow = 2,
      suggestionStyle3ProductItemType = 'list',
      suggestionStyle3ProductPerRow = 3;
    let numberProducts = 4;
    let resultClass = 'boost-sd__instant-search-results boost-sd__instant-search-results--group';

    switch (suggestionStyle) {
      case 'style1': {
        resultClass += ' boost-sd__instant-search-results--one-column';
        resultClass += ` boost-sd__instant-search-results--product-type-${suggestionStyle1ProductItemType}`;
        resultClass += `  boost-sd__instant-search-results--product-position-${suggestionStyle1ProductPosition}`;
        resultClass += `   boost-sd__instant-search-results--product-per-row-${suggestionStyle1ProductPerRow}`;
        numberProducts = 2;
        break;
      }
      case 'style2': {
        resultClass += ' boost-sd__instant-search-results--two-column';
        resultClass += ` boost-sd__instant-search-results--product-type-${suggestionStyle2ProductItemType}`;
        resultClass += `  boost-sd__instant-search-results--product-position-${suggestionStyle2ProductPosition}`;
        resultClass += `   boost-sd__instant-search-results--product-per-row-${suggestionStyle2ProductPerRow}`;
        break;
      }
      case 'style3': {
        resultClass += ' boost-sd__instant-search-results--full-width';
        resultClass += ` boost-sd__instant-search-results--product-type-${suggestionStyle3ProductItemType}`;
        resultClass += `  boost-sd__instant-search-results--product-position-${suggestionStyle3ProductPosition}`;
        resultClass += `   boost-sd__instant-search-results--product-per-row-${suggestionStyle3ProductPerRow}`;
        numberProducts = 6;
        break;
      }
      default:
    }
    return (
      <div className="boost-sd__instant-search-container-desktop">
        <div className="boost-sd__search-widget-init-wrapper">
          <div className={resultClass} style={{ maxWidth: 'fit-content', margin: 'auto' }}>
            <div className="boost-sd__instant-search-autocomplete boost-sd__g-flexColumn">
              <div className="boost-sd__instant-search-column boost-sd__instant-search-column--others">
                <div className="boost-sd__suggestion-queries-group">
                  <h3 className="boost-sd__header-item boost-sd__suggestion-queries-header boost-sd__suggestion-queries-header--suggestions">
                    Popular suggestions
                  </h3>
                  <div className="boost-sd__suggestion-queries-link">
                    <div className="Polaris-SkeletonBodyText skeleton-fullWidth"></div>
                    <div className="Polaris-SkeletonBodyText skeleton-60Width"></div>
                    <div className="Polaris-SkeletonBodyText skeleton-80Width"></div>
                  </div>
                </div>

                <div className="boost-sd__suggestion-queries-group">
                  <h3 className="boost-sd__header-item boost-sd__suggestion-queries-header boost-sd__suggestion-queries-header--collections">
                    Collections
                  </h3>
                  <div className="boost-sd__suggestion-queries-link">
                    <div className="Polaris-SkeletonBodyText skeleton-50Width"></div>
                  </div>
                </div>

                <div className="boost-sd__suggestion-queries-group">
                  <h3 className="boost-sd__header-item boost-sd__suggestion-queries-header boost-sd__suggestion-queries-header--pages">
                    Pages
                  </h3>
                  <div className="boost-sd__suggestion-queries-link">
                    <div className="Polaris-SkeletonBodyText skeleton-fullWidth"></div>
                    <div className="Polaris-SkeletonBodyText skeleton-60Width"></div>
                  </div>
                </div>
              </div>

              <div className="boost-sd__instant-search-column boost-sd__instant-search-column--products">
                <div className="boost-sd__instant-search-group">
                  <div className="boost-sd__instant-search-product-list">
                    <h3 className="boost-sd__header-item boost-sd__instant-search-product-list-header">
                      Products
                    </h3>
                    <ul className="boost-sd__instant-search-product-list-items">
                      {[...Array(numberProducts).keys()].map((item, key) => (
                        <li
                          className="boost-sd__suggestion-queries-item boost-sd__suggestion-queries-item boost-sd__suggestion-queries-item--product"
                          key={key}>
                          <div className="boost-sd__suggestion-queries-item-link">
                            <div className="boost-sd__suggestion-queries-item-product boost-sd__suggestion-queries-item-product--left">
                              <img
                                src={ImageSkeleton}
                                alt="image-skeleton"
                                style={{ width: '100%' }}
                              />
                            </div>
                            <div className="boost-sd__suggestion-queries-item-product boost-sd__suggestion-queries-item-product--right">
                              <div className="Polaris-SkeletonBodyText skeleton-80Width"></div>
                              <div className="Polaris-SkeletonBodyText skeleton-20Width"></div>
                              <div className="Polaris-SkeletonBodyText skeleton-30Width"></div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="boost-sd__instant-search-product-list" style={{ paddingTop: 0 }}>
                    <InstantSearchWidgetBundle formValues={formValues} widget={widget} />
                  </div>
                </div>
                <div className="boost-sd__view-all">
                  <div className="boost-sd__view-all-link">
                    <span className="boost-sd__view-all-text">
                      View all 24 products
                      <svg
                        className="boost-sd__view-all-icon"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M14.1657 7.43443L10.1657 3.43443C9.8529 3.12163 9.3473 3.12163 9.0345 3.43443C8.7217 3.74723 8.7217 4.25283 9.0345 4.56563L11.6689 7.20003H2.4001C1.9577 7.20003 1.6001 7.55843 1.6001 8.00003C1.6001 8.44163 1.9577 8.80003 2.4001 8.80003H11.6689L9.0345 11.4344C8.7217 11.7472 8.7217 12.2528 9.0345 12.5656C9.1905 12.7216 9.3953 12.8 9.6001 12.8C9.8049 12.8 10.0097 12.7216 10.1657 12.5656L14.1657 8.56563C14.4785 8.25283 14.4785 7.74723 14.1657 7.43443"
                          fill="#5C5F62"></path>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch, ownProps) => ({});
const mapStateToProps = (state, props) => {
  return {
    filterSettings: _.get(state.filterSettings, 'filterSettings', {})
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(InstantSearchWidgetPreview));
